<template>
  <div class="matches">
    <v-text-field
      class="input"
      color="green"
      v-model="query"
      placeholder="Namen suchen ..."
      solo
      rounded
      append-icon="search"
    ></v-text-field>

    <div class="matches__header">
      <label>
        <h3>{{ title[type] }}</h3>
      </label>
      <v-chip color="green" text-color="white" small>
        {{ new Intl.NumberFormat('de-DE').format(count) }}
      </v-chip>
    </div>

    <v-container class="results-switches">
      <v-layout row wrap>
        <v-flex xs6 sm3>
          <v-switch
            color="green"
            v-model="switchWithAvatar"
            :label="teamResults ? 'Mit Vereinslogo' : 'Mit Profilbild'"
            class="d-inline-block mr-4 ml-2"
          ></v-switch>
        </v-flex>
        <v-flex xs6 sm3>
          <v-switch
            color="green"
            v-model="switchIsActiveAccount"
            label="Acct. verifiziert"
            class="d-inline-block mr-4 ml-2"
          ></v-switch>
        </v-flex>
        <v-flex xs6 sm3>
          <v-switch
            color="green"
            v-model="switchMatched"
            label="MATCHED!"
            class="d-inline-block mr-4 custom-back custom-back-green"
          ></v-switch>
        </v-flex>
        <v-flex xs6 sm3>
          <v-switch
            color="red"
            v-model="switchDeMatched"
            label="DEMATCHED!"
            class="d-inline-block mr-4 custom-back custom-back-red"
          ></v-switch>
        </v-flex>
        <v-flex xs6 sm3>
          <v-switch
            color="grey"
            v-model="switchWatchlist"
            label="WATCHLIST"
            class="d-inline-block mr-4 custom-back custom-back-grey"
          ></v-switch>
        </v-flex>
      </v-layout>
    </v-container>

    <div
      v-if="
        ((userData.subscriptionData && !userData.subscriptionData.subscriptionId) && userType !== 'teams') ||
        noLeaguePackage
      "
      class="free_swipes_wrapper"
    >
      <v-chip small v-if="bluryResults"> Alle Vereine sichtbar mit Match-Abo. </v-chip>
      <v-chip small v-else> FREE MATCHES: {{ freeMatches }} </v-chip>
    </div>

    <div
      @click="openProfile(item)"
      :class="['player-preview', bluryResults ? 'result-preview-blurry' : '']"
      v-for="item in resultsFiltered"
      :key="`${item.id}-${Math.random()}`"
    >
      <div
        class="profile-img"
        :style="{ backgroundImage: 'url(' + item.big_thumbnail + ')' }"
      ></div>
      <div class="profile-active" v-if="!item.accountNotActivated"></div>
      <div class="profile-name">
        <span class="d-block">
          {{ item.name || item.team_name }}
        </span>
        <div style="display: flex; align-items: center">
          <v-icon
            class="mr-1"
            style="color: rgb(65, 65, 65)"
            v-if="isProfileInWatchlist(item.id)"
            >visibility</v-icon
          >
          <v-chip
            v-if="
              userData.already_matched && userData.already_matched.includes(item.id)
            "
            color="green"
            text-color="white"
            small
            >MATCHED!</v-chip
          >
          <v-chip
            v-else-if="
              userData.already_matched_and_rejected &&
              userData.already_matched_and_rejected.includes(item.id)
            "
            color="red"
            text-color="white"
            small
            >DEMATCHED!</v-chip
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'list-results',

  props: {
    results: {
      type: Array,
      default: () => [],
    },
    userData: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: '',
    },
    count: {
      type: Number,
      default: 0,
    },
    teamResults: {
      type: Boolean,
      default: false,
    },
    bluryResults: {
      type: Boolean,
      default: false,
    },
    noLeaguePackage: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    query(newValue) {
      this.$emit('name-searched', newValue);
    },

    results(newValue) {
      this.resultsFiltered = newValue; // todo: check why after match in filtered list will be shown 2x
    },

    switchMatched(newValue) {
      this.$emit('switch-matched', newValue);
    },

    switchDeMatched(newValue) {
      this.$emit('switch-de-matched', newValue);
    },

    switchWatchlist(newValue) {
      this.$emit('switch-watchlist', newValue);
    },

    switchWithAvatar(newValue) {
      this.$emit('switch-avatar', newValue);
    },
    switchIsActiveAccount(newValue) {
      this.$emit('switch-active-account', newValue);
    },
  },

  data() {
    return {
      title: {
        view_team: 'Passende Vereine',
        view_trainer: 'Passende Trainer',
        view_player: 'Passende Spieler',
      },
      query: null,
      resultsFiltered: [],
      switchMatched: false,
      switchDeMatched: false,
      switchWatchlist: false,
      switchWithAvatar: false,
      switchIsActiveAccount: false,
    };
  },

  computed: {
    ...mapState(['userType']),
    ...mapGetters(['watchlistProfileIds']),

    freeMatches() {
      const matched = this.userData.matches ? this.userData.matches.length : 0;
      const dematched = this.userData.matches_rejected
        ? this.userData.matches_rejected.length
        : 0;
      return 2 - (matched + dematched);
    },
  },

  methods: {
    openProfile(data) {
      if (!this.bluryResults) {
        this.$emit('open-profile', data, this.type);
      }
    },

    isProfileInWatchlist(id) {
      return this.watchlistProfileIds.includes(id);
    },
  },

  mounted() {
    this.resultsFiltered = [...this.results];
  },
};
</script>

<style lang="scss">
.profile-active {
  width: 54px;
  height: 54px;
  top: -2px;
  left: -2px;
  border-radius: 50%;
  position: absolute;
  border: 1px solid #4575bc;
  box-shadow: 0 0 4px #4575bc;
}
.v-chip {
  height: 16px;
  font-size: 11px;
}

.results-switches {
  border-top: 1px solid #efefef;
  border-bottom: 1px solid #efefef;
  margin: 5px 0 10px 0;
  padding: 0;

  width: 100%;

  .v-label {
    font-size: 13px !important;
  }

  .v-messages {
    display: none;
  }

  .custom-back {
    margin-top: 8px;

    // .v-label {
    //   color: white;
    // }

    &-red {
      .v-input__slot {
        padding: 7px 8px;
        background: rgb(255, 210, 210);
      }
    }

    &-green {
      .v-input__slot {
        padding: 7px 8px;
        background: rgb(207, 255, 207);
      }
    }

    &-grey {
      .v-input__slot {
        padding: 7px 8px;
        background: rgb(235, 235, 235);
      }
    }

    &-blue {
      .v-input__slot {
        padding: 7px 8px;
        background: rgb(213, 235, 255);
      }
    }
  }
}

@media (min-width: 0) {
  .flex.xs6 {
    border-bottom: 1px solid #efefef;
  }
}
</style>
